export enum ETipoCausa {
  Inmediata = 2,
  Basica = 1,
  Sistema = 3,
}
